<template>
  <router-view />
</template>

<script>
export default {
  name: 'AppEmptyLayout',
};
</script>

<style scoped></style>
